import React from 'react';
import './block.scss';
import { translate } from "react-translate";
import { Container, Row, Col, Button } from 'react-bootstrap';

class Block extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false
    };

    this.renderImage = this.renderImage.bind(this);
    this.renderText = this.renderText.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }


  renderImage(order) {
    return (
      <Col md={{ span: 5, order: order }} className="align-self-center">
        <div className="imageC">
          <img src={ this.props.image } alt="block" />
        </div>
      </Col>
    );
  }


  renderText(order) {
    return (
      <Col md={{ span: 6, order: order }} className="align-self-center">
        <div className="textC">
          <h4 className="title capsFont">{ this.props.title }</h4>
          { !this.state.modal ? <p className="body bodyFont" dangerouslySetInnerHTML={{ __html: this.props.body }}></p> : '' }
          { this.state.modal ? <p className="fullBody bodyFont" dangerouslySetInnerHTML={{ __html: this.props.fullBody }}></p> : '' }
          { this.props.fullBody && !this.state.modal ?
            <div className="readMoreMini">
              <Button variant="outline-primary" className="bodyFont" onClick={() => this.toggleModal(true)}>{ this.props.t('read_more') }</Button>
            </div>
            : ''
          }
          {
            this.props.button ?
            <div className="readMore">
              <a href={this.props.button}>
                <Button variant="success" className="capsFont">{ this.props.buttonText }</Button>
              </a>
            </div>
            : ''
          }
          {
            this.props.notice ?
            <div className="notice capsFont">
              <span>{ this.props.notice }</span>
            </div>
            : ''
          }
        </div>
      </Col>
    );
  }


  toggleModal(value) {
    let { modal } = this.state;
    modal = value;
    this.setState({ modal });
  }


  render() {
    return (
      <div className={ this.props.whiteBG ? 'component block whiteBG' : 'component block' }>
        <div className="content">
          <Container>
            <Row>
              { this.renderImage(this.props.imageAlign === 'right' ? 2 : 0) }
              <Col md={{ span: 1, order: 1 }}>&nbsp;</Col>
              { this.renderText(this.props.imageAlign === 'right' ? 0 : 2) }
            </Row>
          </Container>
        </div>
      </div>
    );
  }

}

export default translate('Block')(Block);
